import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { IUser } from "../models/user";
import { isUserRole, resolveRole } from "../services/roles";

const GuestGuard = ({ children }: any) => {
  const user = useSelector(({ UserSlice }: any) => UserSlice.user as IUser);

  if (user?.email || user?.username) {
    const role = resolveRole(user?.role);
    const to = isUserRole(role) ? "/devices" : "/main";
    return <Navigate to={to} replace />;
  }

  return <>{children}</>;
};

export default GuestGuard;
